import AuthService from "./authService";
import APIService from "./apiService";
import RegistrationService from "./registrationService.js"

export const useServices = () => {
    const authService = new AuthService()
    const apiService = new APIService(async () => { await authService.logout()})
    const registrationService = RegistrationService
    return {
    
        $auth: authService,
        $api: apiService,
        $registration: registrationService
    }
}